<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredList"
      :search="search"
      class="och-table"
      disable-pagination
      hide-default-footer
      sort-by="name"
    >
      <template v-slot:item="{ item }">
        <tr @click="navigate(item.id)" class="och-tableRow">
          <td>
            {{ item.text }}
          </td>
          <td>
            {{ item.helpText }}
          </td>
          <td>
            {{ filterAnswerList("secQuestionId", item.id).length }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  computed: {
    filteredList() {
      return this.list.filter(
        item => item.parentAnswerId === this.parentAnswerId
      );
    },
    ...mapGetters({
      filterAnswerList: "secAnswer/filterByAttributeValue",
    }),
    ...mapState({
      answerList: state => state.secAnswer.list,
      list: state => state.secQuestion.list,
    }),
  },
  async created() {
    await Promise.all([this.getAnswerList(), this.getList()]);
  },
  data() {
    return {
      headers: [
        {
          text: "Text",
          value: "text",
          align: "start",
        },
        {
          text: "Help Text",
          value: "helpText",
          align: "start",
          sortable: false,
        },
        {
          text: "Answers",
          value: "",
          align: "start",
          sortable: false,
        },
      ],
      search: null,
    };
  },
  methods: {
    navigate(questionId) {
      if (questionId) {
        this.$router.push({
          name: "ochinUserSecurityQuestionForm",
          params: { questionId },
        });
        return;
      }

      this.$router.push({
        name: "ochinUserSecurityQuestionCreate",
      });
    },
    ...mapActions({
      getAnswerList: "secAnswer/list",
      getList: "secQuestion/list",
    }),
  },
  props: ["parentAnswerId"],
};
</script>
